import React from 'react';
import {
  Container,
  Title,
  BreadcrumbNav,
  CrumbItem,
  CrumbLink,
  CrumbText,
} from './styles';
import { Link } from 'react-router-dom';
import { nanoid } from 'nanoid';

interface PageBreadcrumbProps {
  pageTitle: string;
  breadcrumbs?: { label: string; to?: string }[];
}

const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({
  pageTitle,
  breadcrumbs = [],
}) => {
  return (
    <Container>
      <Title>{pageTitle}</Title>
      <BreadcrumbNav>
        <ol>
          {breadcrumbs.map((item) => (
            <CrumbItem key={nanoid()}>
              {item.to ? (
                <CrumbLink to={item.to}>
                  {item.label}
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </CrumbLink>
              ) : (
                <CrumbText>{item.label}</CrumbText>
              )}
            </CrumbItem>
          ))}
        </ol>
      </BreadcrumbNav>
    </Container>
  );
};

export default PageBreadcrumb;
